import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COOKIES_NAME } from "constants/appConstants";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { AuthTokens, sendLogout } from "services/auth";
import { Permisos } from "types/Permisos";
import { Roles } from "enums/Roles";

interface BasicUserInfo {
  id: number;
  name: string;
  lastname: string;
  permissions: Permisos | null;
  picture: string;
  role: Roles;
  // area: number;
  email: string;
}

export interface AuthStateInterface extends BasicUserInfo {
  isLogged: boolean;
  accessToken: string;
  refreshToken: string;
}

const defaultState: AuthStateInterface = {
  id: 0,
  name: "",
  lastname: "",
  permissions: null,
  picture: "",
  role: Roles.Notificador,
  email: "",
  isLogged: false,
  accessToken: "",
  refreshToken: "",
  // area: 2,
};

export interface JwtBasicInfo {
  id: number;
  rol_id: number;
  nombre: string;
  apellido: string;
  imagen_perfil_url: string;
  email: string;
  iat: number;
  exp: number;
}

//const savedTokens = Cookies.get(COOKIES_NAME);
const savedTokens = sessionStorage.getItem(COOKIES_NAME);

const getUserData = (savedTokens: AuthTokens): AuthStateInterface => {
  const userInfo = jwtDecode<JwtBasicInfo>(savedTokens.accessToken);
  return {
    id: userInfo.id,
    name: userInfo.nombre,
    lastname: userInfo.apellido,
    role: userInfo.rol_id,
    email: userInfo.email,
    permissions: null,
    picture: userInfo.imagen_perfil_url,
    ...savedTokens,
    isLogged: true,
  };
};

const initialState: AuthStateInterface =
  savedTokens && savedTokens !== "undefined"
    ? getUserData(JSON.parse(savedTokens))
    : defaultState;

export const logoutAsync = createAsyncThunk(
  "auth/logoutAsync",
  async (_, { dispatch }) => {
    // sendLogout() lee los tokens de sessionStorage de forma sincrónica antes de
    // su await, por lo que la request se arma con el refresh token vigente.
    const logoutRequest = sendLogout();
    // Limpiamos el estado local de inmediato (sin esperar al backend) para que no
    // se disparen mas peticiones autenticadas: si seguimos "logueados" durante el
    // await, el redirect del login rebota a /inicio y vuelve a montar Home, que
    // dispara queries con un token ya revocado (401).
    dispatch(logout());
    try {
      await logoutRequest;
    } catch (error) {
      console.error("Error al cerrar sesión en el servidor", error);
    }
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const tokens: AuthTokens = action.payload;
      sessionStorage.setItem(COOKIES_NAME, JSON.stringify(tokens));
      //Cookies.set(COOKIES_NAME, JSON.stringify(tokens));

      return getUserData(tokens);
    },
    loadToken: (state, action) => {
      const token = action.payload.token;
      return getUserData(token);
    },
    logout: (state) => {
      //Cookies.remove(COOKIES_NAME);
      sessionStorage.removeItem(COOKIES_NAME);
      return defaultState;
    },
  },
});

export const { login, logout, loadToken } = authSlice.actions;

export default authSlice.reducer;
